// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__12gPu","content":"styles_content__2lIPT","selectAll":"styles_selectAll__2cV-A"};